import { Typography, TypographyVariant } from '@mui/material';
import clsx from 'clsx';
import { ReactNode } from 'react';

import { ConditionalProps } from '../../utils';


export type LabeledValueProps = {
    label: ReactNode;
    value: ReactNode;
    classNames?: {
        root?: string;
        label?: string;
        value?: string;
    };
    variants?: {
        label?: TypographyVariant,
        value?: TypographyVariant
    };
} & ConditionalProps<
    { className?: string, variant: 'vertical' },
    { variant?: 'horizontal' }
>;

export function LabeledValue({
    label, value, className, classNames, variants, variant = 'horizontal'
}: LabeledValueProps) {
    const children = (
        <>
            <Typography
                variant={variants?.label || 'caption'}
                color="textSecondary"
                component="div"
                className={classNames?.label}
                textAlign={variant === 'horizontal' ? 'right' : undefined}
            >
                {label}&nbsp;
            </Typography>

            <Typography
                variant={variants?.value || 'body2'}
                component="div"
                className={classNames?.value}
            >
                {value}
            </Typography>
        </>
    );

    return variant === 'horizontal' ? children : (
        <div
            className={clsx(className, classNames?.root)}
            children={children}
        />
    );
}
